import { MediaMatcher } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService, BreadcrumbService, StateService } from 'src/app/services';
import { UserService } from 'src/app/services/user.service';
import { Subscription } from 'rxjs';

/** @title Responsive sidenav */
@Component({
  selector: 'app-partial-layout',
  templateUrl: 'partial.component.html',
  styleUrls: ['partial.component.scss']
})
export class PartialComponent {

  dir = 'ltr';
  useDarkTheme = false;

  green = false;
  blue = false;
  danger = false;

  public get showLoadingBar() {
    return this.breadcrumbService.isLoading$;
  }

  private _subscriptions: Subscription[] = [];

  constructor(
    public router: Router,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private stateService: StateService,
    private authService: AuthService,
    private userService: UserService,
    private breadcrumbService: BreadcrumbService
  ) {
    this._subscriptions.push(this.stateService.state$.subscribe((state) => {
      this.useDarkTheme = state.useDarkTheme;

      if (this.useDarkTheme) {
        this.addDarkMode();
      }
      else {
        this.removeDarkMode();
      }

      if (this.authService.isLoggedIn()) {
        var darkModeClaim: string = this.authService.getClaim("dark_mode");

        if (this.useDarkTheme != (darkModeClaim.toLowerCase() == 'true')) {
          this.userService.updateUserDarkMode(this.useDarkTheme);
        }
      }
    }));
  }

  private removeDarkMode() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('dark');
  }

  private addDarkMode() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('dark');
  }
}